import React, {useState} from 'react';
import styles from './GeneratePersonalDocsModal.module.css';
import Button from '../../Button/Button';
import PickTemplates, {buildPlaceholdersForTemplate} from '../../DocumentTabs/components/PickTemplates/PickTemplates';
import useApi from '../../../hooks/useApi.hook';
import Spinner from '../../Spinner/Spinner';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import {apiErrorMessage} from '../../../helpers/apiError';
import {notifyDownloadQueued} from '../../../helpers/downloadsEvents';
import {getAllDocumentsUrl} from '../../../helpers/constants';

export function GeneratePersonalDocsModal({
	template,
	selectedUsers,
	onClose,
	onSuccess,
	onLoadingChange
}) {
	const api = useApi();
	const [placeholders, setPlaceholders] = useState(
		() => buildPlaceholdersForTemplate(template)
	);
	const [error, setError] = useState(undefined);
	const [loading, setLoading] = useState(false);

	const setGenerating = (value) => {
		setLoading(value);
		onLoadingChange?.(value);
	};

	const handleGenerate = async () => {
		const plh = placeholders
			.filter((p) => p.key?.trim() && p.value?.trim())
			.map((p) => ({ key: p.key, value: p.value }));

		if (!template || selectedUsers.length === 0) return;
		setError(undefined);
		setGenerating(true);
		try {
			const response = await api.post(`${getAllDocumentsUrl}/personal_generate`, {
				template: template.code,
				users_uuid_list: selectedUsers,
				placeholders: plh
			});

			notifyDownloadQueued(response.data);
			onSuccess();
		} catch (e) {
			setError(apiErrorMessage(e));
		} finally {
			setGenerating(false);
		}
	};

	return (
		<div className={styles.container}>
			<h2 className={styles.title}>Сформировать документы</h2>
			<p className={styles.subtitle}>
				{template.title} · выбрано: {selectedUsers.length}
			</p>
			<ErrorMessage
				error={error}
				onClose={() => setError(undefined)}
			/>
			<PickTemplates
				groupName="personal"
				selectedTemplate={template.code}
				setSelectedTemplate={() => {}}
				placeholders={placeholders}
				setPlaceholders={setPlaceholders}
				hideSelect
			/>
			<div className={styles.button}>
				<Button onClick={handleGenerate} disabled={loading}>
					Сформировать
				</Button>
			</div>
			{loading && (
				<div className={styles.spinnerOverlay}>
					<Spinner showSeconds={true} />
				</div>
			)}
		</div>
	);
}
